import { ExecuteUseQuery, useQuery } from "@/hooks/useQuery";

type Wallet = {
    last_trade: string;
    realized_profit: number;
    total_pnl: number;
    total_pnl_percentage: number;
    unrealized_profit: number;
    wallet_address: string;
    winrate: number;
}

export const useGetKol: ExecuteUseQuery<Wallet[], void> = (props = {}) =>
    useQuery('https://n8n.dglab.dev/webhook/pumpy/smartcloner/kols/wallets', props);

export default useGetKol;